"use client";

import ThemeCard from "@/components/pages/hotel/cards/ThemeCard.jsx";
import DistrictList from "@/components/pages/hotel/sections/DistrictList";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import { BlogCard, CampaignCard } from "@/components/featured/common";

export const hotelHomeComponentRegistry = {
  OpportunitiesCardWrapper,
  ThemeCard,
  CampaignCard,
  BlogCard,
  DistrictList
};

export const hotelHomeItemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  ThemeCard: "item",
  BlogCard: "post",
  DistrictList: "item",
};
